import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'
import tools from '@/utils/tools'
export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.config.globalProperties.$tools = tools
  app.config.globalProperties.$baseUrl = import.meta.env.VITE_SERVER_BASEURL
  uni.$tools = tools
  return {
    app,
  }
}
